import { getAdapter } from '../../adapters/AdapterManager';
import CommonAdapter from '../../adapters/CommonAdapter';
import ComposeTimeAdapter from '../../adapters/ComposeTimeAdapter';
import { ApiErrorCode } from '../ApiErrorCode';
import { ApiMethodCallback } from '../ApiMethod';
import { createErrorResult, createSuccessResult } from '../ApiMethodResponseCreator';
import { returnErrorIfUserCannotEditItem } from '../sharedProperties/itemPermissions';
import ComposeRecurrenceAdapter from 'owa-addins-apis/lib/adapters/ComposeRecurrenceAdapter';
import {
    convertRecurrenceToExchangeFormat,
    isValidRecurrence,
    AddinRecurrence,
} from 'owa-addins-recurrence';

export interface SetRecurrenceArgs {
    recurrenceData: AddinRecurrence;
}

export default async function setRecurrenceAsyncApiMethod(
    hostItemIndex: string,
    controlId: string,
    data: SetRecurrenceArgs,
    callback: ApiMethodCallback
) {
    if (!isValidRecurrence(data.recurrenceData)) {
        callback(createErrorResult(ApiErrorCode.InvalidRecurrence));
        return;
    }
    const adapter = getAdapter(hostItemIndex) as ComposeTimeAdapter &
        ComposeRecurrenceAdapter &
        CommonAdapter;

    if (returnErrorIfUserCannotEditItem(adapter, callback)) {
        return;
    }

    if ((await adapter.getSeriesId()) != null) {
        callback(createErrorResult(ApiErrorCode.SetRecurrenceOnInstance));
        return;
    }
    const recurrence = convertRecurrenceToExchangeFormat(data.recurrenceData);
    if (recurrence == null) {
        adapter.setRecurrence(null);
    } else {
        adapter.setStartTime(recurrence.startTime);
        adapter.setEndTime(recurrence.endTime);
        adapter.setRecurrence(recurrence.recurrenceType);
    }
    callback(createSuccessResult());
}
